/** @format */
import {ReactNode} from 'react';

import {HintPopper} from 'components/HintPopper';

import {ButtonsBox} from './styles';
import {SplitButtonSingle} from './SplitButtonSingle';
import {ButtonOption} from './types';

interface Options<V> {
  options: ButtonOption<V>[];
  PopperContent?: ReactNode;
  color: string;
  currentValue?: V | null;
  disabled?: boolean;
}

const SplitButtons = <V extends string>({
  PopperContent,
  options,
  color,
  currentValue,
  disabled,
}: Options<V>) => {
  return (
    <HintPopper PopperContent={PopperContent}>
      <ButtonsBox>
        {options.map(option => (
          <SplitButtonSingle
            key={option.id}
            content={option.content}
            onClick={() => option.onClick(option.id)}
            checked={option.id === currentValue}
            color={color}
            disabled={disabled}
          />
        ))}
      </ButtonsBox>
    </HintPopper>
  );
};

export {SplitButtons};
